export { ErrorBoundaryWrapper } from './lib/components/error-page/variants/error-boundary-page-wrapper'
export { LandingFeatureErrorPage } from './lib/components/error-page/landing-feature-error-page'

export { default as CustomErrorPage } from './lib/components/error-page/variants/custom-error-page'
export { default as SignPost } from './lib/assets/404.svg'

export { getStaticProps } from './lib/get-static-props'
export { Static404Page } from './lib/404'
export { Static500Page } from './lib/500'
